export class UserWrapper {
  constructor() {}

  /**
   * user has consent for analytics cookies
   * (use google analytics)
   * @returns boolean
   */
  analyticsAllowed() {
    throw new Error("You must implement 'analyticsAllowed' for this retailer");
  }

  /**
   * returns the domain for analytics
   */
  analyticsDomain() {
    throw new Error("You must implement 'analyticsAllowed' for this retailer");
  }

  /**
   * user has consent for "function" cookies or profiling cookies
   * (use user id)
   * @returns boolean
   */
  profilingAllowed() {
    throw new Error("You must implement 'profilingAllowed' for this retailer");
  }

  /**
   * @return true if user is logged
   */
  isUserLogged() {
    throw new Error("You must implement 'isUserLoged' for this retailer");
  }

  /**
   * @returns user id for retailer
   */
  getUserId() {
    throw new Error("You must implement 'getUserId' for this retailer");
  }
}
